// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToCartButtonStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToCartButton";
import { addToListLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToListLink";
import { descriptionStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsDescription";
import { quantityOrderedStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsQuantityOrdered";
import { unitOfMeasureSelectStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsUnitOfMeasureSelect";
import { StyledClickable } from "@insite/mobius/Link";
import { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { initializeScrollTo } from "@mcmc/App/Libraries";
import { screen } from "@mcmc/XDL/Helpers";
import { mergeWithCss, onPrint, printStyles, Roboto } from "@mcmc/XDL/Utilities";
import { css } from "styled-components";

export const valueTextStyle: TypographyProps = {
    size: 14,
    lineHeight: "20px",
    className: "mcmc-part-number",
    weight: "normal",
    css: css`
        display: block;
        padding: 10px 15px;

        ${onPrint(css`
            padding: 5px 0;
        `)}
    `,
};

export const labelTextStyle: TypographyPresentationProps = {
    size: 14,
    weight: "bold",
    css: css`
        margin-right: 5px;
    `,
};

descriptionStyles.wrapper = {
    css: css`
        font-size: 14px;
        letter-spacing: 0.2px;
        line-height: 16px;
        margin: 20px 0;
        ${screen("lte", "lg")`
            margin-top: 0;
        `}
    `,
};

quantityOrderedStyles.quantityOrdered = {
    sizeVariant: "default",
    labelPosition: "left",
    labelProps: {
        weight: "normal",
        lineHeight: "40px",
        css: css`
            width: auto;
            padding: 0 10px 0 0;
        `,
    },
    cssOverrides: {
        formField: css`
            width: auto;
            min-width: 0;
            margin: 12px 5px;
        `,
        inputSelect: css`
            width: 55px;
            background-color: ${getColor("text.inverse")};
        `,
    },
};

addToCartButtonStyles.button = {
    css: css`
        width: 155px;
        margin: 12px 5px;
        span {
            font-size: 14px;
        }
    `,
};

addToListLinkStyles.wrapper = {
    css: css`
        margin: 12px 5px;
    `,
};

addToListLinkStyles.link = {
    link: {
        typographyProps: {
            size: 16,
        },
    },
};

unitOfMeasureSelectStyles.unitOfMeasureSelect = mergeWithCss(unitOfMeasureSelectStyles.unitOfMeasureSelect, {
    sizeVariant: "default",
    labelPosition: "left",
    labelProps: {
        weight: "normal",
        size: 16,
        lineHeight: "40px",
        css: css`
            width: auto;
            padding: 0 10px 0 0;
        `,
    },
    cssOverrides: {
        formField: [printStyles.hideOnPrint],
    },
});

descriptionStyles.wrapper = mergeWithCss(descriptionStyles.wrapper, {
    css: css`
        ${StyledClickable} {
            &,
            span {
                font-weight: normal;
                font-family: ${Roboto.fontFamily};
                letter-spacing: 0.2px;
            }
        }
    `,
    onClick: (event: any) => {
        const target = event.target;
        const parentTarget = event.target?.parentElement;

        let clickedElement;
        if (target?.dataset?.moveToTab) {
            clickedElement = target;
        } else if (parentTarget?.dataset?.moveToTab) {
            clickedElement = parentTarget;
        }

        if (clickedElement) {
            const scrollTarget: any = document.querySelector(`[id*='${clickedElement.dataset.moveToTab}']`);
            if (scrollTarget) {
                scrollTarget.click();
                initializeScrollTo("[data-test-selector='productDetails_specifications']");
            }
        }
    },
});
